import {
    CompanySettingModel,
    DailyTransactionTypeEnum,
    LookupItemModel,
    LookupTypeEnum, TransactionDetailResponseModel,
    UserSettingModel, UserTransactionsSettingResponseModel,UserConfigurationModel
} from "../../models";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import {getLookupByType} from "../../serviceBroker/lookupApiServiceBroker";
import {getUserSetting, getUserTransactionsSettings} from "../../serviceBroker/userApiServiceBroker";
import {getUserId} from "../../utils";
import {SystemConfiguration} from "../../configuration";
import {
    companySettingInitialValues, getCompanySettings,
    initializeTransactionValuesAndUserTransactionsConfiguration,
    userSettingInitialValues,
    userTransactionsSettingInitialValues
} from "../../components/transactions/common/businessLogic/transactionBl";
import {useGenericSystemConfigurations} from "../configurations/useGenericSystemConfigurations";

// const isSalesComponent = (transactionType: DailyTransactionTypeEnum): boolean => {
//     const salesTransactionTypes: DailyTransactionTypeEnum[] = [
//         DailyTransactionTypeEnum.SalesInvoice,
//         DailyTransactionTypeEnum.SalesRefund,
//         DailyTransactionTypeEnum.ShowPrice,
//         DailyTransactionTypeEnum.Order,
//         DailyTransactionTypeEnum.POSSales,
//         DailyTransactionTypeEnum.POSSalesRefund,
//         DailyTransactionTypeEnum.POSRestaurant,
//         DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
//         DailyTransactionTypeEnum.ReturnPOSRestaurant,
//     ];
//
//     return salesTransactionTypes.includes(transactionType);
// };

export const useTransaction = (transactionType:DailyTransactionTypeEnum, setLoading:Dispatch<SetStateAction<boolean>>,data:TransactionDetailResponseModel,setData:Dispatch<SetStateAction<TransactionDetailResponseModel>>) => {
    //#region functions
    const makeSafeArray = <T>(input: T[] | null | undefined): T[] => {
        return Array.isArray(input) ? input : [];
    };
    //#endregion
    //#region variables
    const _isSalesComponent: boolean = [
        DailyTransactionTypeEnum.SalesInvoice,
        DailyTransactionTypeEnum.SalesRefund,
        DailyTransactionTypeEnum.ShowPrice,
        DailyTransactionTypeEnum.Order,
        DailyTransactionTypeEnum.POSSales,
        DailyTransactionTypeEnum.POSSalesRefund,
        DailyTransactionTypeEnum.POSRestaurant,
        DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
        DailyTransactionTypeEnum.ReturnPOSRestaurant,
    ].includes(transactionType);
    //#endregion
    //#region useEffect
    useEffect(() => {
        const fillData = async () => {
            setLoading(true);
            await fillBasicDataPromiseAll();
            setLoading(false);
        };
        fillData().then(() => {
        });
    }, []);
    //#endregion
    //#region state
    const { genericSystemConfigurations, isConfigurationLoaded } = useGenericSystemConfigurations();
    const [beneficiaryList, setBeneficiaryList] = useState<LookupItemModel[]>([]);
    const [categoryList, setCategoryList] = useState<LookupItemModel[]>([]);
    const [itemsPerCategoryList, setItemPerCategoryList] = useState<LookupItemModel[]>([]);
    const [itemList, setItemList] = useState<LookupItemModel[]>([]);
    const [paymentTypeList, setPaymentTypeList] = useState<LookupItemModel[]>([]);
    const [currencyList, setCurrencyList] = useState<LookupItemModel[]>([]);
    const [storeEmployeeList, setStoreEmployeeList] = useState<LookupItemModel[]>([]);
    const [costCenterList, setCostCenterList] = useState<LookupItemModel[]>([]);
    const [calcTypeList, setCalcTypeList] = useState<LookupItemModel[]>([]);
    const [storeList, setStoreList] = useState<LookupItemModel[]>([]);
    const [userSetting, setUserSetting] = useState<UserSettingModel>(userSettingInitialValues);
    const [companySetting,setCompanySetting]=useState<CompanySettingModel>(companySettingInitialValues)
    const [_, setUserTransactionSettingList] = useState<UserTransactionsSettingResponseModel[]>([]);
    const [userTransactionSetting, setUserTransactionSetting] = useState<UserTransactionsSettingResponseModel>(userTransactionsSettingInitialValues);

    const [isSalesComponent] = useState(_isSalesComponent);
    const [isTransactionLoaded, setIsTransactionLoaded] = useState(false);
    const [hasSingleStore, setHasSingleStore] = useState(false);
    //#endregion
    //#region function
    const fillBasicDataPromiseAll = async () => {
        let  stores = await getLookupByType(LookupTypeEnum.Stores, true, false);
        stores=stores??[];
        const  _hasSingleStore =  stores.length <= 1;
        setHasSingleStore(_hasSingleStore);
        const [
            beneficiaryLookupList,
            CategoryLookupList,
            itemLookupList,
            paymentTypeLookupList,
            currencyLookupList,
            employeeLookupList,
            calcTypeLookupList,
            costCenterLookupList,
            _userSetting,
            _userTransactionSettingList,
            _companySetting
        ] = await Promise.all([
            isSalesComponent
                ? getLookupByType(LookupTypeEnum.Customers, true, false)
                : getLookupByType(LookupTypeEnum.Supplier, true, false),
            getLookupByType(LookupTypeEnum.CategoryType, true, true),
            _hasSingleStore ?getLookupByType(LookupTypeEnum.Items, true, true):Promise.resolve([]),
            getLookupByType(LookupTypeEnum.PaymentType, true, true),
            getLookupByType(LookupTypeEnum.Currency, true, true),
            getLookupByType(LookupTypeEnum.Employee, true, true),
            getLookupByType(LookupTypeEnum.CalcType, true, false),
            getLookupByType(LookupTypeEnum.CostCenter, true, true),
            getUserSetting(getUserId()),
            getUserTransactionsSettings(
                [
                    DailyTransactionTypeEnum.SalesInvoice,
                    DailyTransactionTypeEnum.PurchasesInvoice,
                    DailyTransactionTypeEnum.SalesRefund,
                    DailyTransactionTypeEnum.PurchasesRefund,
                    DailyTransactionTypeEnum.Order,
                    DailyTransactionTypeEnum.ShowPrice,
                    DailyTransactionTypeEnum.POSSales,
                    DailyTransactionTypeEnum.POSSalesRefund,
                    DailyTransactionTypeEnum.POSRestaurant,
                    DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
                    DailyTransactionTypeEnum.ReturnPOSRestaurant,
                ],
                true,
                SystemConfiguration.cacheKey_Configurations.setting.userTransactionSettingsList
            ),
            getCompanySettings()
        ]);
        setBeneficiaryList(makeSafeArray(beneficiaryLookupList));
        setCategoryList(makeSafeArray(CategoryLookupList));
        setItemPerCategoryList(makeSafeArray(itemLookupList));
        setItemList(makeSafeArray(itemLookupList));
        setPaymentTypeList(makeSafeArray(paymentTypeLookupList));
        setCurrencyList(makeSafeArray(currencyLookupList));
        setStoreEmployeeList(makeSafeArray(employeeLookupList));
        setCalcTypeList(makeSafeArray(calcTypeLookupList));
        setCostCenterList(makeSafeArray(costCenterLookupList));
        setStoreList(makeSafeArray(stores));
        setUserSetting(_userSetting??userSettingInitialValues);
        setUserTransactionSettingList(_userTransactionSettingList);
        setCompanySetting(_companySetting);
        const currentTransactionSetting = _userTransactionSettingList?.find(
            (p) => p.TransactionType_ID === transactionType
        ) || null;
        setUserTransactionSetting(currentTransactionSetting || userTransactionsSettingInitialValues);
        data.defaultStoreId=_hasSingleStore?Number( stores[0]?.value):null;
        if(data.ID==null ||data.ID==0) {
            await initializeTransactionValuesAndUserTransactionsConfiguration(
                setData,
                data,
                [
                    {key: "customers", value: beneficiaryLookupList},
                    {key: "payments", value: paymentTypeLookupList},
                    {key: "currencies", value: currencyLookupList},
                    {key: "employees", value: employeeLookupList},
                    {key: "calcTypes", value: calcTypeLookupList},
                    {key: "costCenters", value: costCenterLookupList},
                ],
                currentTransactionSetting || userTransactionsSettingInitialValues  //,"key2"
            );
        }
        setIsTransactionLoaded(true);
    };

    //#endregion
    return {
        beneficiaryList:beneficiaryList??[], setBeneficiaryList,
        categoryList:categoryList??[], //setCategoryList,
        itemsPerCategoryList:itemsPerCategoryList??[], setItemPerCategoryList,
        itemList:itemList??[], setItemList,
        paymentTypeList:paymentTypeList??[],// setPaymentTypeList,
        currencyList:currencyList??[],// setCurrencyList,
        storeEmployeeList:storeEmployeeList??[], //setStoreEmployeeList,
        costCenterList:costCenterList??[], //setCostCenterList,
        calcTypeList:calcTypeList??[], //setCalcTypeList,
        storeList:storeList??[], //setStoreList,
        //userSetting, //setUserSetting,
        //userTransactionSettingList, setUserTransactionSettingList,
        //userTransactionSetting, //setUserTransactionSetting,
        userConfiguration:{
            userSetting,
            companySetting,
            userTransactionSetting,
            genericSystemConfiguration:genericSystemConfigurations,
        } as UserConfigurationModel,
        isSalesComponent,
        isTransactionLoaded,
        hasSingleStore,
        defaultStoreId:Number(storeList[0]?.value)
    }
}